import { Factory } from 'rosie';

Factory.define('ApiTokens').attr('name', 'API_TOKENS');

Factory.define('ApiTokensWithDefaults').extend('ApiTokens');



// WEBPACK FOOTER //
// ./factories/location/api_tokens.js